import React from 'react';
import './GridStyles.scss';

export default function VerticalGridBody(props) {
  const {
    rows,
    data,
    onClickByRow = () => {},
  } = props;

  const onSelectRow = (item, index) => event => {
    onClickByRow(item, event, index);
  };

  const renderRow = (key, index) => (
    <tr
      key={index}
      className="data-table-row"
      onClick={onSelectRow(data[key], index)}
    >
      <td className="data-table-cell">
        {rows[key]}
      </td>
      <td className="data-table-cell">
        {data[key]}
      </td>
    </tr>
  );
  const keys = Object.keys(rows);
  return (
    <tbody className="data-table-content">
      {keys && keys.map(renderRow)}
    </tbody>
  );
}
